export default "__VITE_ASSET__DS56IjrZ__"